import React from 'react';
import ReactDOM from 'react-dom';
import App from './Pages/App/App';
import reportWebVitals from './reportWebVitals';
import './Services/AppInsightsService';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import { I18nProviderWrapper } from './Models/Context/I18nProvider';
import { ThemeProviderWrapper } from './Theming/ThemeProvider';
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./Components/ErrorPage/ErrorPage";
import appInsightsInstance from "./Services/AppInsightsService";
import { isPhoneBrowser } from './Services/Utils';
import BrowserNotSupported from './Components/BrowserNotSupported/BrowserNotSupported';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <I18nProviderWrapper>
                <ThemeProviderWrapper>
                    <ErrorBoundary onError={(error) => appInsightsInstance.appInsights.trackException({ exception: error }, { fromGlobalErrorBoundary: true })} FallbackComponent={ErrorPage}>
                        {isPhoneBrowser() ? <BrowserNotSupported /> : <App />}
                    </ErrorBoundary>
                </ThemeProviderWrapper>
            </I18nProviderWrapper>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
